import { TIMEOUT_SEC } from "./config";

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

export const getJSON = async function (url) {
  try {
    const res = await Promise.race([fetch(url), timeout(TIMEOUT_SEC)]);
    const data = await res.json();

    if (!res.ok) throw new Error(`${data.message} Status code: ${res.status}`);
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getRandomInt = function (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
